import React, { JSX } from 'react';
import { MANAGE_ITEM_MODE } from '../../../../../../../../_constants/manageConst';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { MANAGE_ITEM_ROW_TYPE } from '../../../../../../../../_constants/manageConst';
import {
  CategoryMaster,
  TypeMaster,
  ItemMaster,
} from '../../../../../../../../services/apiTypes';
import useSortItem from '../../../../../../hooks/useSortItem';
import { Options } from '../../../../../../ManageInspectionItem';
import EditDepth2Row from './EditDepth2Row';
import { DisplayDepth2Row } from './DisplayDepth2Row';

type itemDepth2ItemsProps = {
  type: TypeMaster;
  item1: ItemMaster;
  targetItem: ItemMaster;
  categoryMaster: CategoryMaster[];
  setCategoryMaster: React.Dispatch<React.SetStateAction<CategoryMaster[]>>;
  typeMaster: TypeMaster[];
  setTypeMaster: React.Dispatch<React.SetStateAction<TypeMaster[]>>;
  itemMaster: ItemMaster[];
  setItemMaster: React.Dispatch<React.SetStateAction<ItemMaster[]>>;
  displayMode: number;
  isOpenAccordions: Record<string, boolean>;
  isAdmin: boolean;
  stickyPosition: number[];
  options: Options;
  handleItemInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    item: ItemMaster,
  ) => ItemMaster;
  checkInputForCondition: (item: ItemMaster) => boolean;
  onClickItemEditSave: (item: ItemMaster) => void;
  onClickItemEditCancel: () => void;
  onClickItemNamesEdit: (item: ItemMaster) => void;
  onClickItemEditIcon: (data: ItemMaster) => void;
  onClickItemDeleteIcon: (data: ItemMaster) => void;
  isSetPFRCodes: (item: ItemMaster) => boolean;
  isDisabledBtn: boolean;
  multiAutoCompleteMenu: (
    props: React.HTMLAttributes<HTMLLIElement> & {
      key: React.Key;
    },
    selected: boolean,
    itemName: string,
  ) => JSX.Element;
};

const ItemDepth2Items: React.FC<itemDepth2ItemsProps> = ({
  type,
  item1,
  targetItem,
  categoryMaster,
  setCategoryMaster,
  typeMaster,
  setTypeMaster,
  itemMaster,
  setItemMaster,
  displayMode,
  isOpenAccordions,
  isAdmin,
  stickyPosition,
  options,
  handleItemInputChange,
  checkInputForCondition,
  onClickItemEditIcon,
  onClickItemNamesEdit,
  onClickItemEditCancel,
  onClickItemEditSave,
  onClickItemDeleteIcon,
  isSetPFRCodes,
  isDisabledBtn,
  multiAutoCompleteMenu,
}) => {
  const { SortableItem } = useSortItem({
    categoryMaster,
    setCategoryMaster,
    typeMaster,
    setTypeMaster,
    itemMaster,
    setItemMaster,
    displayMode,
    isSetPFRCodes,
    targetItem,
  });

  return (
    <SortableContext
      id={MANAGE_ITEM_ROW_TYPE.ITEM}
      items={itemMaster
        .filter((i) => {
          return (
            i.typeId === type.typeId &&
            i.depth === 2 &&
            i.parentItemId === item1.itemId
          );
        })
        .map((item) => item.itemId)}
      strategy={verticalListSortingStrategy}
    >
      {itemMaster
        .filter((i) => {
          return (
            i.typeId === type.typeId &&
            i.depth === 2 &&
            i.parentItemId === item1.itemId
          );
        })
        .map((item2) => {
          // 階層2の時、表示する項目か判定するため階層0のIDを取得する
          let depth0Id = '';
          if (item2.depth === 2) {
            depth0Id =
              itemMaster.find((i) => i.itemId === item2.parentItemId)
                ?.parentItemId ?? '';
          }
          // 編集または追加モードで対象itemIdと一致したらeditDepth表示にする
          const isEditItem =
            (displayMode === MANAGE_ITEM_MODE.ADD ||
              displayMode === MANAGE_ITEM_MODE.EDIT) &&
            targetItem.itemId === item2.itemId;

          return (
            item2.parentItemId &&
            isOpenAccordions[item2.parentItemId] && (
              <SortableItem
                key={`item_${item2.itemId}`}
                id={item2.itemId}
                name={MANAGE_ITEM_ROW_TYPE.ITEM}
              >
                {item2.parentItemId && isOpenAccordions[item2.parentItemId] && (
                  <>
                    {isOpenAccordions[depth0Id] &&
                      (isEditItem ? (
                        <EditDepth2Row
                          item={targetItem}
                          options={options}
                          mode={displayMode}
                          isAdmin={isAdmin}
                          stickyPosition={stickyPosition}
                          isDisabledBtn={isDisabledBtn}
                          handleInputChange={handleItemInputChange}
                          checkInputForCondition={checkInputForCondition}
                          onClickOk={onClickItemEditSave}
                          onClickCancel={onClickItemEditCancel}
                          onClickNamesEdit={onClickItemNamesEdit}
                          multiAutoCompleteMenu={multiAutoCompleteMenu}
                        />
                      ) : (
                        <DisplayDepth2Row
                          item={item2}
                          mode={displayMode}
                          isAdmin={isAdmin}
                          stickyPosition={stickyPosition}
                          onClickEditIcon={onClickItemEditIcon}
                          onClickDeleteIcon={onClickItemDeleteIcon}
                        />
                      ))}
                  </>
                )}
              </SortableItem>
            )
          );
        })}
    </SortableContext>
  );
};

export default ItemDepth2Items;
